export default "__VITE_ASSET__BMvQJLsv__"